"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var vue_property_decorator_1 = require("vue-property-decorator");
var CreditCardForm = /** @class */ (function (_super) {
    __extends(CreditCardForm, _super);
    function CreditCardForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            creditCardNumber: "",
            creditCardExpMonth: "",
            creditCardExpYear: "",
            creditCardCVV: ""
        };
        return _this;
    }
    Object.defineProperty(CreditCardForm.prototype, "cardNumberMask", {
        get: function () {
            if (this.currentCardType.value === "amex") {
                return "#### ###### #####";
            }
            else {
                return "#### #### #### ####";
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreditCardForm.prototype, "years", {
        get: function () {
            return lodash_1.default.range(this.currentYear, this.currentYear + 50);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreditCardForm.prototype, "months", {
        get: function () {
            return [
                {
                    abbreviation: "Jan",
                    name: "January",
                    number: 1,
                },
                {
                    abbreviation: "Feb",
                    name: "February",
                    number: 2,
                },
                {
                    abbreviation: "Mar",
                    name: "March",
                    number: 3,
                },
                {
                    abbreviation: "Apr",
                    name: "April",
                    number: 4,
                },
                {
                    abbreviation: "May",
                    name: "May",
                    number: 5,
                },
                {
                    abbreviation: "Jun",
                    name: "June",
                    number: 6,
                },
                {
                    abbreviation: "Jul",
                    name: "July",
                    number: 7,
                },
                {
                    abbreviation: "Aug",
                    name: "August",
                    number: 8,
                },
                {
                    abbreviation: "Sep",
                    name: "September",
                    number: 9,
                },
                {
                    abbreviation: "Oct",
                    name: "October",
                    number: 10,
                },
                {
                    abbreviation: "Nov",
                    name: "November",
                    number: 11,
                },
                {
                    abbreviation: "Dec",
                    name: "December",
                    number: 12,
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreditCardForm.prototype, "currentYear", {
        get: function () {
            return (0, moment_1.default)().year();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreditCardForm.prototype, "cardTypes", {
        get: function () {
            return [
                {
                    value: "master",
                    display: "Master Card",
                    cvvDigits: 3,
                    regex: /^(5[1-5]|2)/,
                },
                {
                    value: "visa",
                    display: "Visa",
                    cvvDigits: 3,
                    regex: /^4/,
                },
                {
                    value: "discover",
                    display: "Discover",
                    cvvDigits: 3,
                    regex: /^6/,
                },
                {
                    value: "amex",
                    display: "American Express",
                    cvvDigits: 4,
                    regex: /^3[47]/,
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreditCardForm.prototype, "currentCardType", {
        get: function () {
            var _this = this;
            var search = this.cardTypes.filter(function (x) {
                return x.regex.test(_this.form.creditCardNumber);
            });
            return search.length
                ? search[0]
                : {
                    type: "other",
                    cvvDigits: null,
                };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreditCardForm.prototype, "cardDiscoveredMessage", {
        get: function () {
            if (this.form.creditCardNumber.length < 4) {
                return "";
            }
            if (this.currentCardType.value === "other") {
                return "Unknown card used.";
            }
            else {
                return "".concat(this.currentCardType.display, " discovered.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreditCardForm.prototype, "availableMonthsForCurrentYear", {
        get: function () {
            var currentMonth = (0, moment_1.default)().month();
            return this.months.filter(function (x) { return x.number > currentMonth; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreditCardForm.prototype, "onCurrentYear", {
        get: function () {
            return this.creditCardExpYear === this.currentYear;
        },
        enumerable: false,
        configurable: true
    });
    CreditCardForm.prototype.mounted = function () {
        this.form.creditCardNumber = this.creditCardNumber;
        this.form.creditCardExpMonth = this.creditCardExpMonth;
        this.form.creditCardExpYear = this.creditCardExpYear;
        this.form.creditCardCVV = this.creditCardCVV;
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: String, required: true })
    ], CreditCardForm.prototype, "creditCardNumber", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Number, required: true })
    ], CreditCardForm.prototype, "creditCardExpMonth", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Number, required: true })
    ], CreditCardForm.prototype, "creditCardExpYear", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: String, required: false })
    ], CreditCardForm.prototype, "creditCardCVV", void 0);
    CreditCardForm = __decorate([
        vue_property_decorator_1.Component
    ], CreditCardForm);
    return CreditCardForm;
}(vue_property_decorator_1.Vue));
exports.default = CreditCardForm;
